export const URI_DASHBOARD_ACCESSRULE = "/api/dashboard/access-rule";
export const URI_DASHBOARD_ACCESSRULE_DEVICE_X = "/api/dashboard/access-rule/device/:deviceUuid";
export const URI_DASHBOARD_ACCESSRULE_X = "/api/dashboard/access-rule/:uuid";
